module.exports = __webpack_public_path__ + "img/farm.a2e5e70a.svg";